module.exports = __webpack_public_path__ + "img/lifting-station-lg-on.46a1ad4e.svg";